'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Button } from './button';

const CookieBanner = () => {
	const [showBanner, setShowBanner] = useState(false);

	useEffect(() => {
		// Client-side only check
		const consent = localStorage.getItem('cookie_consent');
		if (consent === null) {
			setShowBanner(true);
		}
	}, []);

	const handleConsent = (consentType: 'accepted' | 'rejected') => {
		localStorage.setItem('cookie_consent', consentType);
		setShowBanner(false);
		// Here you would typically initialize analytics or other scripts if consent was accepted
		if (consentType === 'accepted') {
			// Example: window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
			console.log(
				'Cookies aceites. Scripts de analytics podem ser carregados.'
			);
		} else {
			console.log(
				'Cookies rejeitados. Scripts de analytics não serão carregados.'
			);
		}
	};

	if (!showBanner) {
		return null;
	}

	return (
		<div className="fixed bottom-0 left-0 right-0 bg-background border-t border-border p-4 z-50 shadow-lg animate-in slide-in-from-bottom-5">
			<div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
				<p className="text-sm text-muted-foreground text-center md:text-left">
					Este site utiliza cookies para garantir a melhor experiência de
					navegação. Consulte a nossa{' '}
					<Link
						href="/cookies"
						className="font-semibold underline hover:text-primary"
					>
						Política de Cookies
					</Link>
					.
				</p>
				<div className="flex items-center gap-2 flex-shrink-0">
					<Button
						variant="default"
						size="sm"
						onClick={() => handleConsent('accepted')}
					>
						Aceitar
					</Button>
					<Button
						variant="outline"
						size="sm"
						onClick={() => handleConsent('rejected')}
					>
						Rejeitar
					</Button>
					{/* A "Configurar" button would require a modal with more granular controls which can be a future enhancement */}
				</div>
			</div>
		</div>
	);
};

export default CookieBanner;
